import { z } from 'zod'

export const TemplateFieldSchema = z.object({
  wizard_enabled: z.boolean().optional(),
  is_template_field: z.boolean().optional(),
  value: z.string().nullish(),
  template_field_id: z.number(),
})
